import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'

//import 'nprogress/nprogress.css'

Vue.use(Router)

let router = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import( /* webpackPrefetch: true */ './views/Home.vue')
        },
        
    ]
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
})

router.afterEach(() => {
    NProgress.done()
})

export default router = router;
